/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Order_Needs_Sellable_LineInputs */

const vi_validation_order_needs_sellable_line = /** @type {(inputs: Validation_Order_Needs_Sellable_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn cần ít nhất 1 sản phẩm hoặc 1 vật tư có đơn giá`)
};

/**

* @param {Validation_Order_Needs_Sellable_LineInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const validation_order_needs_sellable_line = /** @type {((inputs?: Validation_Order_Needs_Sellable_LineInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Order_Needs_Sellable_LineInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_validation_order_needs_sellable_line(inputs)
});